var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key},[_c('div',{staticClass:"container-component"},[_c('div',{staticClass:"row d-flex flex-column"},[_c('h2',{staticClass:"mb-2"},[_vm._v(" Welcome "+_vm._s(_vm.user?.firstname + " " + _vm.user?.lastname)+"! ")]),_c('span')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }